import * as React from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { type LegalEntity } from 'modules/employees/hooks/useLegalEntities'
import type { TableSelection } from 'modules/employees/pages/EditInBulk/hooks/useTableSelection'
import {
  CustomField,
  EmployeeCustomFieldsValue,
  EmployeeGroups,
} from 'modules/employees/pages/EditInBulk/types'
import type { ColumnNames } from 'modules/employees/pages/EditInBulk/vars'
import type Employee from 'modules/employees/store/models/Employee'

import DataTable from './DataTable'
import columns from './columns'

interface Props {
  employees: Employee[]
  legalEntities: LegalEntity[]
  tableSelection: TableSelection
  onSelect: (columnName: ColumnNames, selectedId: number) => void
  onAllSelect: (column: ColumnNames, selectedIds: number[]) => void
  options: React.ReactNode
  employeeGroups: EmployeeGroups[]
  customFields: CustomField[]
  customFieldsValues: EmployeeCustomFieldsValue[]
}

const Body = ({
  employees,
  legalEntities,
  tableSelection,
  onSelect,
  onAllSelect,
  options,
  employeeGroups,
  customFields,
  customFieldsValues,
}: Props) => {
  if (!employees.length) {
    return (
      <>
        {options}
        <Table fullWidth>
          <Table.Body>
            <Table.Blank colSpan={12} text={i18n.t('employees.no_employees_found')} />
          </Table.Body>
        </Table>
      </>
    )
  }

  return (
    <Box gap="s8" height="full">
      {options}
      <DataTable
        employees={employees}
        legalEntities={legalEntities}
        columns={columns(legalEntities.length, employeeGroups.length, customFields)}
        tableSelection={tableSelection}
        onSelect={onSelect}
        onAllSelect={onAllSelect}
        employeeGroups={employeeGroups}
        customFields={customFields}
        customFieldsValues={customFieldsValues}
      />
    </Box>
  )
}

export default Body
